export default __webpack_public_path__ + "static/media/about-team-kate-bennett.e85f6510.png";